import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getOperationEntitiesByGroupForDropDown,
    getCollectionCategoryByOperationEntityForDropDown,
    getCollectionPointsByOperationentityGroupID,
    getReportData,
    getGangByCollectionPointID,
    GetAvialableFieldsForDropdown
};

async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getCollectionCategoryByOperationEntityForDropDown(operationEntityID) {
    var collectionCategory = [];
    var response = await CommonGet('/api/CollectionCategory/GetCollectionCategoryByOperationEntityID', "operationEntityID=" + parseInt(operationEntityID));
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true)
            collectionCategory[item[1]["collectionCategoryID"]] = item[1]["collectionCategoryName"];
    }
    return collectionCategory;
}

async function getCollectionPointsByOperationentityGroupID(operationEntityID, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function getReportData(collectionPointID, fieldID, pluckingType, gangID, startDate) {
    const response = await CommonGet('/api/LabourChecklistReport/GetPlukingChecklistReportDetails',
        'collectionPointID=' + parseInt(collectionPointID) + '&fieldID=' + parseInt(fieldID) + '&startDate=' + startDate
        + '&pluckingType=' + pluckingType + '&gangID=' + parseInt(gangID));

    return response.data;
}

async function getGangByCollectionPointID(operationEntityID, collectionPointID) {
    var gangArray = [];
    const response = await CommonGet('/api/Gang/GetGangBySearch', "operationEntityID=" + parseInt(operationEntityID) + '&collectionPointID=' + parseInt(collectionPointID));
    for (let item of Object.entries(response.data)) {
        gangArray[item[1]["gangID"]] = item[1]["gangName"]
    }
    return gangArray;
}

async function GetAvialableFieldsForDropdown(collectionPointID) {
    var fieldArray = [];
    const response = await CommonGet('/api/DailyFieldPerformanceReport/GetFieldsByDivision', 'divisionID=' + parseInt(collectionPointID));
    for (let item of Object.entries(response.data)) {
        fieldArray[item[1]["fieldID"]] = item[1]["fieldName"]
    }
    return fieldArray;
}
